import { render } from "./ClipboardListSvg.vue?vue&type=template&id=d57d8ad8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__